import { render, staticRenderFns } from "./QuotaMessage.vue?vue&type=template&id=959acab8&scoped=true"
import script from "./QuotaMessage.vue?vue&type=script&lang=js"
export * from "./QuotaMessage.vue?vue&type=script&lang=js"
import style0 from "./QuotaMessage.vue?vue&type=style&index=0&id=959acab8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959acab8",
  null
  
)

export default component.exports